// @flow

import type { RouteComponent } from 'common/router'

const ROUTES_MAP = Object.freeze({
  HOME: '/',
  TEACHER: '/teacher',
  GR: '/gr',
  MATH: '/math',
  IT: '/it',
  ENG: '/eng',
  RUSSIAN: '/russian',
})

export const ROUTES = [
  {
    exact: true,
    path: ROUTES_MAP.HOME,
    component: (): RouteComponent => import('./home'),
  },
  {
    exact: true,
    path: ROUTES_MAP.GR,
    component: (): RouteComponent => import('./home'),
  },
  {
    exact: true,
    path: ROUTES_MAP.TEACHER,
    component: (): RouteComponent => import('./teacher'),
  },
  {
    exact: true,
    path: ROUTES_MAP.MATH,
    component: (): RouteComponent => import('./subjects'),
    componentData: {
      VISIT_TAG: {
        id: 1233,
        value: 'math-olymp.foxford.ru | visited',
      },
    },
  },
  {
    exact: true,
    path: ROUTES_MAP.ENG,
    component: (): RouteComponent => import('./subjects'),
    componentData: {
      VISIT_TAG: {
        id: 1231,
        value: 'eng-olymp.foxford.ru | visited',
      },
    },
  },
  {
    exact: true,
    path: ROUTES_MAP.IT,
    component: (): RouteComponent => import('./subjects'),
    componentData: {
      VISIT_TAG: {
        id: 1229,
        value: 'it-olymp.foxford.ru | visited',
      },
    },
  },
  {
    exact: true,
    path: ROUTES_MAP.RUSSIAN,
    component: (): RouteComponent => import('./subjects'),
    componentData: {
      VISIT_TAG: {
        id: 1227,
        value: 'russian-olymp.foxford.ru | visited',
      },
    },
  },
]
